module.exports = __webpack_public_path__ + "assets/images/attachment-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/attachment-on.png
// module id = 1484
// module chunks = 1